// extracted by mini-css-extract-plugin
export var locationsContainer = "_z7-2";
export var locationsTextContainer = "_z7-1";
export var mapContainer = "_z7-0";